import React from 'react';

/**
 * Full-width responsive banner. Clicking the banner takes the visitor
 * directly to the printer search page.
 */
export default function SetupBanner({ pageTitle }) {
  return (
    <a
      href="/search"
      className="setup-banner"
      aria-label={pageTitle ? `${pageTitle} — start printer setup` : 'Start printer setup'}
    >
      {pageTitle && <h1 className="visually-hidden">{pageTitle}</h1>}
      <img
        src="/setup-banner-v2.jpg"
        alt="Start printer setup"
      />
    </a>
  );
}
